import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
  input,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { Search, LucideIconData } from 'lucide-angular';
import { IconComponent } from '../../../../shared/ui/icon/icon.component';
import { BLOG_COPY } from '../../constants/blog.constants';

@Component({
  selector: 'app-blog-search',
  imports: [IconComponent],
  templateUrl: './blog-search.component.html',
  styleUrl: './blog-search.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BlogSearchComponent implements OnInit {
  value = input('');

  searchChange = output<string>();

  protected readonly searchIcon: LucideIconData = Search;
  protected readonly copy = BLOG_COPY;

  private readonly input$ = new Subject<string>();
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.input$
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((query) => this.searchChange.emit(query));
  }

  protected onInput(event: Event): void {
    this.input$.next((event.target as HTMLInputElement).value.trim());
  }
}
